var _require = require('./JwksClient'),
    JwksClient = _require.JwksClient;

var errors = require('./errors');

var _require2 = require('./integrations/hapi'),
    hapiJwt2Key = _require2.hapiJwt2Key,
    hapiJwt2KeyAsync = _require2.hapiJwt2KeyAsync;

var _require3 = require('./integrations/express'),
    expressJwtSecret = _require3.expressJwtSecret;

var _require4 = require('./integrations/koa'),
    koaJwtSecret = _require4.koaJwtSecret;

var _require5 = require('./integrations/passport'),
    passportJwtSecret = _require5.passportJwtSecret;

module.exports = function (options) {
  return new JwksClient(options);
};

module.exports.JwksClient = JwksClient;
module.exports.ArgumentError = errors.ArgumentError;
module.exports.JwksError = errors.JwksError;
module.exports.JwksRateLimitError = errors.JwksRateLimitError;
module.exports.SigningKeyNotFoundError = errors.SigningKeyNotFoundError;
module.exports.expressJwtSecret = expressJwtSecret;
module.exports.hapiJwt2Key = hapiJwt2Key;
module.exports.hapiJwt2KeyAsync = hapiJwt2KeyAsync;
module.exports.koaJwtSecret = koaJwtSecret;
module.exports.passportJwtSecret = passportJwtSecret;